import { render, staticRenderFns } from "./SendTestModal.vue?vue&type=template&id=71b1b95e"
import script from "./SendTestModal.vue?vue&type=script&lang=js"
export * from "./SendTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports